import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { resizeImage, reformatDate } from "../../shared/utils";
import { useCurrentViewportView } from "../../hooks/useCurrentViewportView";
import { AiFillStar } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BsFillPlayFill } from "react-icons/bs";
import Skeleton from "../Common/Skeleton";

const BannerSlider = ({ films, dataDetail, isLoadingBanner }) => {
  const { isMobile } = useCurrentViewportView();
  return (
    <div className="mt-2 md:mt-4 relative h-0 pb-[85%] sm:pb-[60%] lg:pb-[50%]">
      {isLoadingBanner ? (
        <Skeleton className="absolute top-0 left-0 w-full h-full rounded-lg" />
      ) : (
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{ delay: 500000, disableOnInteraction: false }}
          slidesPerView={1}
          className="!absolute !top-0 !left-0 !w-full !h-full  !rounded-lg"
        >
          {films.map((film, index) => (
            <SwiperSlide key={film.id}>
              <LazyLoadImage
                src={
                  isMobile
                    ? resizeImage(film.poster_path, "w780")
                    : resizeImage(film.backdrop_path, "w1280")
                }
                alt="Backdrop image"
                effect="blur"
              />
              <div className="absolute top-0 left-0 w-full h-full rounded-lg pointer-events-none tw-black-backdrop hover:bg-[#00000026] transition duration-7000"></div>
              <div className="absolute top-[5%] right-[3%] bg-gradient-to-br from-primary to-orange-600 px-3 py-1 rounded-full text-white flex items-center gap-1">
                <span>{film.vote_average.toFixed(1)}</span>
                <AiFillStar size={15} />
              </div>

              <div className="absolute top-[4%] left-[8%] md:top-[8%] md:left-[5%] md:max-w-md max-w-[250px]">
                <h2 className="md:text-4xl text-3xl text-primary font-black tracking-wide tw-multiline-ellipsis-2">
                  {film.title || film.name}
                </h2>
                <p className="text-white font-semibold text-xl md:text-2xl mt-1 md:mt-3 tw-multiline-ellipsis-1">
                  {dataDetail[index].translation[0] ||
                    dataDetail[index].translation[1] ||
                    dataDetail[index].translation[2] ||
                    dataDetail[index].translation[3] ||
                    dataDetail[index].translation[4] ||
                    dataDetail[index].translation[5]}
                </p>
                <p className="text-base mt-1">
                  {film.release_date &&
                    `${!isMobile ? "Release date:" : ""} ${reformatDate(
                      film.release_date
                    )}`}
                  {film.first_air_date &&
                    `${!isMobile ? "Last episode date:" : ""} ${reformatDate(
                      film.first_air_date
                    )}`}
                </p>
                <div className="flex gap-2 flex-wrap mt-3 max-h-[45px] overflow-hidden md:max-h-[90px]">
                  {dataDetail[index].genre.map((genre) => (
                    <div
                      className="px-3 py-2 border rounded-full mr-2 tw-shaded-button text-white text-sm"
                      key={genre.id}
                    >
                      {genre.name}
                    </div>
                  ))}
                </div>
                <p className="mt-1 md:mt-3 text-base tw-multiline-ellipsis-2 md:tw-multiline-ellipsis">
                  {film.overview}
                </p>
                <Link
                  to={
                    film.media_type === "movie"
                      ? `/movie/${film.id}`
                      : `/tv/${film.id}`
                  }
                  className="block w-fit"
                >
                  <button
                    className="flex justify-center items-center px-3 py-2 w-[125px] mt-2 md:mt-4 mb-2 rounded-full 
                              bg-gradient-to-br from-primary to-orange-600 text-white group hover:scale-105 transition duration-500"
                  >
                    <p>Watch</p>
                    <div className="w-8 h-8 ml-2 rounded-full bg-white flex items-center justify-center">
                      <BsFillPlayFill
                        size={30}
                        className="text-orange-700 group-hover:animate-spinplay transition duration-700"
                      />
                    </div>
                  </button>
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default BannerSlider;
